import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import Chip from '@mui/material/Chip';
import React from 'react';
import AppTooltip from '../AppTooltip/AppTooltip';
import { vars } from '../../../Theme';
import { SxProps } from '@mui/material';

const defaultChipSx: SxProps = {
    background: vars.brandDarkBlue,
    color: 'white',
};

export default ({
    tooltip,
    key,
    label,
    onClick,
    onDeleteClick,
    chipSx: overrideChipSx,
}: IChipWithTooltipProps) => (
    <AppTooltip title={tooltip ?? ''}>
        <Chip
            key={key}
            label={label}
            clickable={Boolean(onClick)}
            onClick={onClick}
            onDelete={onDeleteClick}
            deleteIcon={
                <Icon
                    path={mdiClose}
                    style={{
                        minWidth: '22px',
                        minHeight: '22px',
                        maxWidth: '22px',
                        maxHeight: '22px',
                        color: vars.white,
                    }}
                />
            }
            sx={{ ...defaultChipSx, ...overrideChipSx }}
        />
    </AppTooltip>
);

interface IChipWithTooltipProps {
    label: string;
    key?: React.Key;
    tooltip?: string;
    onClick?: () => void;
    onDeleteClick?: () => void;
    chipSx?: SxProps;
}
